import { useState } from "react";
import { Link } from "react-router-dom";
import { Download, Search } from "lucide-react";
import { api, euro, data, errMsg, STATO_CARD } from "@/lib/api";
import { Page } from "@/components/Layout";

export const formatCodice = (v) =>
  v.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 16).replace(/(.{4})(?=.)/g, "$1-");

export default function VerificaSaldo() {
  const [codice, setCodice] = useState("");
  const [res, setRes] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const verifica = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    setRes(null);
    try {
      const r = await api.post("/pubblico/saldo", { codice });
      setRes(r.data);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  const pdf = async () => {
    try {
      const r = await api.post("/pubblico/giftcard/pdf", { codice }, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `giftcard-${codice.slice(-4)}.pdf`;
      a.click();
    } catch (e2) {
      setErr("Download non riuscito: troppi tentativi o codice non valido.");
    }
  };

  return (
    <Page className="max-w-2xl">
      <p className="caption">Verifica saldo</p>
      <h1 className="font-display text-4xl sm:text-5xl mt-2">Quanto resta sulla tua gift card?</h1>
      <p className="text-[#786E65] mt-3">Inserisci il codice di 16 caratteri riportato sul PDF o nell'email. Per sicurezza i tentativi sono limitati.</p>
      <form onSubmit={verifica} className="card mt-8 flex flex-col sm:flex-row gap-3">
        <input className="field font-code tracking-widest text-lg" placeholder="XXXX-XXXX-XXXX-XXXX" value={codice}
          onChange={(e) => setCodice(formatCodice(e.target.value))} data-testid="saldo-codice-input" />
        <button className="btn-primary" disabled={codice.length !== 19 || busy} data-testid="saldo-verifica-btn"><Search size={16} />Verifica</button>
      </form>
      {err && <p className="mt-4 text-red-700" data-testid="saldo-error">{err}</p>}
      {res && (
        <div className="card mt-6 fade-up" data-testid="saldo-result">
          <div className="flex justify-between items-start gap-4">
            <div>
              <p className="caption">{res.operatore}</p>
              <p className="font-display text-5xl text-[#7E5BAF] mt-2" data-testid="saldo-importo">{euro(res.saldo_cent)}</p>
              <p className="text-sm text-[#786E65] mt-1">su {euro(res.importo_cent)} · scade il {data(res.scadenza)}</p>
            </div>
            <span className={STATO_CARD[res.stato]} data-testid="saldo-stato">{res.stato}</span>
          </div>
          <div className="flex flex-wrap gap-3 mt-6">
            <button onClick={pdf} className="btn-secondary" data-testid="saldo-pdf-btn"><Download size={16} />Scarica PDF</button>
            <Link to={`/vetrina/${res.operatore_id}`} className="btn-outline">Vai alla vetrina</Link>
          </div>
        </div>
      )}
    </Page>
  );
}
